import React from 'react';
import { motion } from 'framer-motion';
import { Section } from './ui/Section';
import { Kicker, H2 } from './ui/Typography';
import { useT } from '../i18n/LanguageContext';
const HEADSHOT_URL = 'https://cdn.shopify.com/s/files/1/0736/0194/1549/files/ChatGPT_Image_Apr_24_2026_05_09_34_PM.png?v=1777075795';
export function FounderSection() {
  const t = useT().founder;
  return <Section hasOrb={true} data-id="element-74">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-75">
        <div data-id="element-76">
          <Kicker data-id="element-77">{t.kicker}</Kicker>
          <H2 data-id="element-78">{t.title}</H2>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.01
        }} transition={{
          duration: 0.5
        }} className="text-ink-dim text-lg leading-relaxed" data-id="element-79">
            {t.desc}
          </motion.p>
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        amount: 0.01
      }} transition={{
        duration: 0.5
      }} className="relative aspect-square rounded-[16px] overflow-hidden border-[2px] border-border-strong" data-id="element-80">
          <div className="absolute pointer-events-none" style={{
          width: 600,
          height: 600,
          top: -150,
          right: -150,
          background: 'radial-gradient(circle, rgba(250,255,0,0.2) 0%, rgba(250,255,0,0) 70%)',
          filter: 'blur(40px)',
          zIndex: 0
        }} data-id="element-81" />
          <img src={HEADSHOT_URL} alt="Cesar Navarro" className="absolute inset-0 w-full h-full object-cover z-10" data-id="element-82" />
          <div className="absolute inset-x-0 bottom-0 h-1/3 z-20 pointer-events-none" style={{
          background: 'linear-gradient(to top, rgba(10,10,10,0.6) 0%, rgba(10,10,10,0) 100%)'
        }} data-id="element-83" />
          <div className="absolute bottom-5 left-5 z-30 flex items-center gap-2" data-id="element-84">
            <span className="font-mono text-xs font-bold text-black bg-brand px-2 py-1 rounded-[4px] uppercase tracking-[0.18em]" data-id="element-85">
              {t.badge1}
            </span>
            <span className="font-mono text-xs text-ink uppercase tracking-[0.18em]" data-id="element-86">
              {t.badge2}
            </span>
          </div>
        </motion.div>
      </div>
    </Section>;
}